/* eslint-disable no-underscore-dangle */
import React, { useState, useContext, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';

import { ImageWrapper, InputWrapper, RatingsWrapper, SmileyLabel } from '../../../customise/components/styled/common';
import AmazingUnclicked from '../../images/smileys/amazing_unclicked.png';
import NeutralUnclicked from '../../images/smileys/neutral_unclicked.png';
import AmazingClicked from '../../images/smileys/amazing_clicked.png';
import NeutralClicked from '../../images/smileys/neutral_clicked.png';
import HappyUnclicked from '../../images/smileys/happy_unclicked.png';
import AngryUnclicked from '../../images/smileys/angry_unclicked.png';
import { FormContext } from '../../../shared/contexts/form-context';
import AngryClicked from '../../images/smileys/angry_clicked.png';
import SadUnclicked from '../../images/smileys/sad_unclicked.png';
import HappyClicked from '../../images/smileys/happy_clicked.png';
import { setUserInputOnCtrl } from '../../../form/reducer/form';
import { getEmptyTableFields } from '../../../../shared/utils';
import SadClicked from '../../images/smileys/sad_clicked.png';
import { ControlPropType } from '../../ctrl_proptype';

const SmileyFaces = ({ ctrl, inTable, col, tr }) => {
  const dispatch = useDispatch();
  const { inForm, currentPageNo } = useContext(FormContext);

  const [newCtrl, setNewCtrl] = useState(ctrl);
  const [smileyMap, setSmileyMap] = useState([
    {
      name: 'Angry',
      unclicked: AngryUnclicked,
      clicked: AngryClicked,
      id: `${ctrl.internal_id}_angry`,
      imageId: `${ctrl.internal_id}-img-angry`,
    },
    {
      name: 'Sad',
      unclicked: SadUnclicked,
      clicked: SadClicked,
      id: `${ctrl.internal_id}_sad`,
      imageId: `${ctrl.internal_id}-img-sad`,
    },
    {
      name: 'Neutral',
      unclicked: NeutralUnclicked,
      clicked: NeutralClicked,
      id: `${ctrl.internal_id}_neutral`,
      imageId: `${ctrl.internal_id}-img-neutral`,
    },
    {
      name: 'Happy',
      unclicked: HappyUnclicked,
      clicked: HappyClicked,
      id: `${ctrl.internal_id}_happy`,
      imageId: `${ctrl.internal_id}-img-happy`,
    },
    {
      name: 'Amazing',
      unclicked: AmazingUnclicked,
      clicked: AmazingClicked,
      id: `${ctrl.internal_id}_amazing`,
      imageId: `${ctrl.internal_id}-img-amazing`,
    }
  ]);

  useEffect(() => {
    if (inForm && ctrl.value) {
      const newSmileyMap = [...smileyMap];
      if (inTable && ctrl.value[tr - 1][col - 1]) {
        const selectSmiley = newSmileyMap.find((smiley) => smiley.name === ctrl.value[tr - 1][col - 1]);
        selectSmiley.click = true;
        const index = smileyMap.findIndex((smiley) => smiley.name === ctrl.value[tr - 1][col - 1]);
        newSmileyMap[index] = selectSmiley;
        setSmileyMap(newSmileyMap);
      } else if (!inTable) {
        const selectSmiley = newSmileyMap.find((smiley) => smiley.name === ctrl.value);
        selectSmiley.click = true;
        const index = smileyMap.findIndex((smiley) => smiley.name === ctrl.value);
        newSmileyMap[index] = selectSmiley;
        setSmileyMap(newSmileyMap);
      }
    }
  }, []);

  const handleSmileyClick = (name, i) => {
    if (inForm) {
      const newSmileyMap = [...smileyMap];
      const selectPrevClick = newSmileyMap.find((smiley) => smiley.click === true);
      delete selectPrevClick?.click;
      const selectSmiley = newSmileyMap.find((smiley) => smiley.name === name);
      selectSmiley.click = true;
      newSmileyMap[i] = selectSmiley;
      setSmileyMap(newSmileyMap);
      if (inTable) {
        const control = cloneDeep(newCtrl);
        if (!newCtrl.value) {
          control.value = getEmptyTableFields(newCtrl.props.min_rows, newCtrl.props.columns);
          control._validationError = getEmptyTableFields(newCtrl.props.min_rows, newCtrl.props.columns);
          control.value[tr - 1][col - 1] = name;
          setNewCtrl(control);
        } else {
          control.value[tr - 1][col - 1] = name;
          setNewCtrl(control);
        }
      } else {
        setNewCtrl((prevCtrl) => ({ ...cloneDeep(prevCtrl), value: name }));
      }
      dispatch(
        setUserInputOnCtrl({
          newValue: name,
          property: 'value',
          page: currentPageNo - 1,
          ctrlId: ctrl.internal_id,
          isValid: true,
          ...(inTable && { tr: tr - 1, col: col - 1 }),
        })
      );
    }
  };

  return (
    <RatingsWrapper id={!inTable ? `fpl-${ctrl.internal_id}` : null}>
      {smileyMap.map((smiley, i) => (
        <span
          key={smiley.id}
          role="button"
          tabIndex={0}
          onClick={() => handleSmileyClick(smiley.name, i)}
          onKeyDown={() => handleSmileyClick(smiley.name, i)}>
          <InputWrapper type="radio" name={smiley.name} value={smiley.name} />
          <SmileyLabel htmlFor={smiley.id}>
            <ImageWrapper
              title={smiley.name}
              src={smiley?.click ? smiley.clicked : smiley.unclicked}
              alt={smiley.name}
            />
          </SmileyLabel>
        </span>
      ))}
    </RatingsWrapper>
  );
};

SmileyFaces.defaultProps = {
  inTable: false,
  col: null,
  tr: null,
};

SmileyFaces.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  inTable: PropTypes.bool,
  col: PropTypes.number,
  tr: PropTypes.number,
};

export default SmileyFaces;
